import _ from 'lodash';
import React from 'react';
import FormattedField from './formatted-field';

class Percent extends FormattedField {
	get prefix () {
		return '%';
	}

	format (value) {
		if (_.isEmpty(value)) {

			return '';
		}

		value = window.parseInt(value.replace(/[^\d]+/, ''), 10);
		return `${value < 1 ? value * 100 : value}%`.replace(/nan/i, '0');
	}

	removeFormatting (value) {
		return window.parseInt(value.replace(/[^\d]+/, ''), 10) / 100;
	}
}

export default Percent;
